import { useLayoutEffect, type RefObject } from 'react';

// где стоял на каждой вкладке — на время сессии: ушёл на другой экран и вернулся — там же, где ушёл (Глеб, 2026-09-11)
const memo = new Map<string, { left: number; top: number }>();

/** Прокрутка контейнера помнится по ключу на время сессии: при появлении восстанавливается, дальше записывается. */
export function useScrollMemory(ref: RefObject<HTMLElement | null>, key: string | null, ready = true) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !key || !ready) return;
    const m = memo.get(key);
    el.scrollLeft = m?.left ?? 0; el.scrollTop = m?.top ?? 0;
    const save = () => memo.set(key, { left: el.scrollLeft, top: el.scrollTop });
    el.addEventListener('scroll', save, { passive: true });
    return () => el.removeEventListener('scroll', save);
  }, [ref, key, ready]);
}
